


















































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import indicador_mes_frecuencias from '@/mixins/axios/indicador_mes_frecuencias'
import indicador_frecuencias from '@/mixins/axios/indicador_frecuencias'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
       columnasd:[
            
             
            
            {
                tag:'mes',
                data:'mes',
                active:true
            },
            {
                tag:'abreviacion',
                data:'abreviacion',
                active:true
            },
            {
                tag:'num_mes',
                data:'num_mes',
                active:true
            }, {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
       ],
   



        id:null as any,
   mes:'' as any,
      abreviacion:'' as any,
      num_mes:null as any,

         
              indicador_mes_frecuenciasdata:[] as any,
              indicador_frecuencias:[] as any,
      
    }
  },
     mixins: [indicador_mes_frecuencias],
     validations: {
    
           mes: {
      required,
    },
      abreviacion: {
      required,
    },
     num_mes: {
      required,
    },
    
         
     

   
  },
  methods:{
        
      async eliminar(row){
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_INDICADOR_MES_FRECUENCIA(row).then(response => {

                    if (response != null) {

 this.indicador_mes_frecuenciasdata=this.indicador_mes_frecuenciasdata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar indicador_mes_frecuencias, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
     
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
       

         
                 this.mes=null;

            this.abreviacion=null;
             this.num_mes=null;
           
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_indicador_mes_frecuencias').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.mes=row.mes;

            this.abreviacion=row.abreviacion;
             this.num_mes=row.num_mes;

            
             
 $('#ac_modal_indicador_mes_frecuencias').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_INDICADOR_MES_FRECUENCIA(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.indicador_mes_frecuenciasdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar indicador_mes_frecuencias, refresque la pagina");

                    }    $("#ac_modal_indicador_mes_frecuencias").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_INDICADOR_MES_FRECUENCIA(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicardo mes frecuencia modificado exitosamente, refresque la pagina");
  this.indicador_mes_frecuenciasdata=this.indicador_mes_frecuenciasdata.filter(item => item.id !== dat.id);
 this.indicador_mes_frecuenciasdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar indicador mes frecuencias, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
           
           mes:this.mes,

            abreviacion:this.abreviacion,
             num_mes:this.num_mes,
             frecuencia:this.$store.state.frecuancia_sel.id,
            idmunicipio:this.$store.state.user.usuario.id_municipio

    
}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
      async getFrec() {
   this.$root.$emit('loading', true);
 console.log('loaddding')
let data= await this.GET_FRECUENCIA().then(response => {

                    if (response != null) {
                        //this.plantas = response;
this.indicador_frecuencias=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");

                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
  frecuencia:this.$store.state.frecuancia_sel.id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};


let data= await this.GET_INDICADOR_MES_FRECUENCIA(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_mes_frecuenciasdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      this.getFrec();
      //alert('10')
  }
})
export default class Home extends Vue {}

